<template>
  <BaseCard>
    <Flex direction="column">
      <BaseHeading>
        {{ $t('website_service.onboarding.terms.subscription_summary') }}
      </BaseHeading>
      <Flex
        direction="column"
        :gap="0"
      >
        <BaseHeading size="s">
          {{ $t('website_service.onboarding.terms.add_on_price') }}
        </BaseHeading>
        <BaseText bold>
          {{ $t('website_service.onboarding.terms.price', { price }) }}
        </BaseText>
      </Flex>
      <Flex
        direction="column"
        :gap="0"
      >
        <BaseHeading size="s">
          {{ $t('website_service.onboarding.terms.start_date') }}
        </BaseHeading>
        <Flex
          :direction="$screen === 's' ? 'column' : 'row'"
          align="center"
        >
          <BaseText bold>
            {{ $t(newTerms
              ? 'website_service.onboarding.terms.start_date_info_v2'
              : 'website_service.onboarding.terms.start_date_info') }}
          </BaseText>
          <BaseLabel
            v-if="newTerms"
            color="warning"
            v-test="'onboarding-terms-changed-label'"
          >
            {{ $t('global.changed') }}
          </BaseLabel>
        </Flex>
      </Flex>
      <Flex
        v-if="domain"
        direction="column"
        :gap="0"
      >
        <BaseHeading size="s">
          {{ $t('website_service.dashboard.domain') }}
        </BaseHeading>
        <BaseText bold>{{ domain }}</BaseText>
      </Flex>
    </Flex>
  </BaseCard>
</template>

<script
  setup
  lang="ts"
>
import { computed, inject, type Ref } from 'vue';
import type { Website } from '@/types';

withDefaults(
  defineProps<{
    newTerms?: boolean;
  }>(),
  {
    newTerms: false,
  },
);

const price = inject<Ref<string>>('price');
const website = inject<Ref<Website>>('website');

const domain = computed(() => website?.value?.url);
</script>
